import { loadable } from '@elliemae/pui-app-sdk';

export const LoadableRulesEditor = loadable(
  () =>
    import(
      /* webpackChunkName: "schema" */ /* webpackPrefetch: true */ './rule-editor-view'
    ),
  null, // use wait message from html
);
